(() => {
  const GRID_SELECTOR = '[data-about-events-scroll]';
  const DRAG_THRESHOLD = 12;

  function initGrid(grid) {
    if (!grid || grid.dataset.dragScrollInit === 'true') return;
    grid.dataset.dragScrollInit = 'true';

    let isMouseDown = false;
    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;
    let maxDeltaX = 0;
    let suppressClickUntil = 0;

    function endDrag() {
      if (!isMouseDown) return;
      isMouseDown = false;
      grid.classList.remove('is-pointer-down');
      if (isDragging) {
        suppressClickUntil = Date.now() + 160;
      }
      isDragging = false;
      grid.classList.remove('is-dragging');
    }

    grid.addEventListener('mousedown', (event) => {
      if (event.button !== 0) return;

      isMouseDown = true;
      isDragging = false;
      startX = event.clientX;
      startScrollLeft = grid.scrollLeft;
      maxDeltaX = 0;
      grid.classList.add('is-pointer-down');
    });

    window.addEventListener('mousemove', (event) => {
      if (!isMouseDown) return;

      const deltaX = event.clientX - startX;
      const absDeltaX = Math.abs(deltaX);
      if (absDeltaX > maxDeltaX) maxDeltaX = absDeltaX;

      if (!isDragging && absDeltaX >= DRAG_THRESHOLD) {
        isDragging = true;
        grid.classList.add('is-dragging');
      }

      if (!isDragging) return;

      grid.scrollLeft = startScrollLeft - deltaX;
      event.preventDefault();
    });

    // Prevent native browser drag behavior on images/links inside cards.
    grid.addEventListener('dragstart', (event) => {
      event.preventDefault();
    });

    window.addEventListener('mouseup', endDrag);
    window.addEventListener('blur', endDrag);

    grid.addEventListener(
      'click',
      (event) => {
        if (Date.now() <= suppressClickUntil && maxDeltaX >= DRAG_THRESHOLD) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );
  }

  function initAll(root = document) {
    root.querySelectorAll(GRID_SELECTOR).forEach(initGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
